import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderAddDeleteButton,
  renderAdditionalComments,
  renderFile,
  renderMultiTextBox,
  renderEffectiveDate,
} from "./RenderUtils";

export class AddDeleteMortgageeRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderAddDeleteButton(
            "Add/Delete Mortgagee",
            request,
            updateRequest
          )}
          {renderTextBox(
            "fullNameOfMortgagee",
            "Full Name of mortgagee",
            request,
            updateRequest,
            "Name of Mortgagee"
          )}
          {renderMultiTextBox(
            "addressOfMortgagee",
            "Address of mortgagee",
            request,
            updateRequest
          )}
          {renderTextBox(
            "loanNumber",
            "Loan number (if available)",
            request,
            updateRequest,
            "Loan Number"
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
